import React, { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { useGetSitesQuery } from '../../services/api';
import Loading from '../../components/Loading';
import useCompanyOptions from '../../hooks/useCompanyOptions';
import useSelectedCompany from '../../hooks/useSelectedCompany';

const CompanyMaps = () => {
    const theme = useTheme();
    // Company and group options
    const { companyOptions } = useCompanyOptions();
    const { selectedCompanyId } = useSelectedCompany({ companyOptions });

    // API
    const { data: sitesData, isLoading } = useGetSitesQuery(selectedCompanyId, {
        skip: !selectedCompanyId,
        refetchOnMountOrArgChange: true // Auto-refresh when company changes
    });

    const qatarCenter = { lat: 25.249469, lng: 51.472279 };

    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (event) => {
        const { clientX, clientY } = event;
        setMousePosition({ x: clientX, y: clientY });
    };

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: '0.55rem',
                overflow: 'hidden',
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
                width: '100%',
                height: '103%',
                position: 'relative',
            }}
        >
            {isLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 1,
                    }}
                >
                    <Loading />
                </Box>
            )}

            <Box sx={{ height: '100%', width: '100%', position: 'relative' }} onMouseMove={handleMouseMove}>
                <APIProvider apiKey="AIzaSyAHJh02Ky1BfcvzBWPOew7ZLytA-1HY1Hc">
                    {!isLoading && sitesData && selectedCompanyId ? (
                        <Map style={{ width: '100%', height: '100%' }} defaultCenter={qatarCenter} defaultZoom={10} gestureHandling="greedy" disableDefaultUI={true}>
                            {sitesData.map((site) => {
                                const lat = parseFloat(site.latitude);
                                const lng = parseFloat(site.longitude);

                                if (isNaN(lat) || isNaN(lng)) {
                                    return null;
                                }

                                const isOnline = site.connectedMACs?.some((device) => device.status === 'ONLINE');
                                const iconUrl = isOnline ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';

                                return (
                                    <Marker
                                        key={site._id}
                                        position={{ lat, lng }}
                                        title={site.name}
                                        icon={{ url: iconUrl }}
                                        onMouseOver={() => setHoveredMarker(site)}
                                        onMouseOut={() => setHoveredMarker(null)}
                                    />
                                );
                            })}
                        </Map>
                    ) : (
                        <Loading />
                    )}
                </APIProvider>

                {hoveredMarker && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: mousePosition.y + 10,
                            left: mousePosition.x + 10,
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                            padding: '8px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                            zIndex: 2,
                            pointerEvents: 'none',
                        }}
                    >
                        <h3
                            style={{
                                margin: 0,
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                        >
                            {hoveredMarker.name}
                        </h3>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default CompanyMaps;
